import { render } from "./ComplianceOverview.vue?vue&type=template&id=f767c90c&scoped=true"
import script from "./ComplianceOverview.vue?vue&type=script&lang=js"
export * from "./ComplianceOverview.vue?vue&type=script&lang=js"

import "./ComplianceOverview.vue?vue&type=style&index=0&id=f767c90c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f767c90c"]])

export default __exports__